<template>
  <!--  云商严选图标-->
  <div style="word-break: keep-all;">
    <div
      v-for="(item, index) in tagList"
      :key="index"
      class="cloud-shop-selected-2"
      :style="getLabelStyle(item)"
    >
      <div :style="{ color: item.wordColor }">
        {{ item.tagContent }}
      </div>
    </div>
    <div
      v-for="type in typeList"
      :key="type"
      style="display: inline-block;transform: translateY(-1px);"
    >
      <div :class="`${typeMap.get(type)}`">
        <div>{{ type }}</div>
      </div>
    </div>
    <div class="low-price-label" v-if="labelItem.isLower">同款最低价</div>
  </div>
</template>

<script>
export default {
  name: "mew-goods-tag",
  props: {
    typeList: {
      type: Array,
      default() {
        return [];
      }
    },
    labelItem: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    tagList() {
      // return [];
      return this.labelItem.tagList || [];
    }
  },
  methods: {
    getLabelStyle(item) {
      return {
        color: item.wordColor || "#000", // 设置默认颜色
        marginRight: "5px",
        background: item.backgroundColor || "#fff"
      };
    }
  },
  data() {
    return {
      typeMap: new Map([
        ["集采", "concentrated-purchasing-tag"],
        ["联采", "combined-purchasing-tag"],
        ["自采", "self-purchasing-tag"],
        ["自营", "self-run-tag"],
        ["二级集采", "concentrated-purchasing-tag"],
        ["内贸企业", "concentrated-purchasing-tag"],
        ["协议", "concentrated-purchasing-tag"]
      ])
    };
  }
};
</script>

<style lang="scss">
.shop-type {
  display: inline-block;
  /*width: 51px;*/
  height: 18px;
  background: #ff142f;
  border-radius: 9px;
  padding: 0 7px;
  box-sizing: border-box;
  div {
    /*width: 36px;*/
    height: 17px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 17px;
  }
}

@mixin tag-background {
  /*width: 34px;*/
  height: 16px;
  border-radius: 2px;
  padding: 0 3px;
  margin-right: 5px;
  box-sizing: border-box;
  display: inline-block;
}

@mixin tag-font {
  /*width: 24px;*/
  height: 16px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
}
.cloud-shop-selected-2 {
  @include tag-background;
  display: inline-block;
  margin-bottom: 1px;
  transform: translateY(-1px);
  padding: 0 5px;
  height: 17px;
  font-size: 12px;
  line-height: 17px;
}
.concentrated-purchasing-tag {
  @include tag-background;
  background: #ff142f;

  div {
    @include tag-font;
    font-weight: 400;
    color: #ffffff;
  }
}
.concentrated-purchasing-tag-equip {
  @include tag-background;
  background: #2a79ff;

  div {
    @include tag-font;
    font-weight: 400;
    color: #ffffff;
  }
}

.combined-purchasing-tag {
  @include tag-background;
  background: #f5a623;

  div {
    @include tag-font;
    color: #ffffff;
  }
}

.self-purchasing-tag {
  @include tag-background;
  background: #0089ef;

  div {
    @include tag-font;
    color: #ffffff;
  }
}

.self-run-tag {
  @include tag-background;
  // border: 1px solid #ff142f;
  background: #409eff;
  padding: 0 4px;
  div {
    @include tag-font;
    // color: #ff142f;
    color: #fff;
    line-height: 15px;
  }
}
.low-price-label {
  border-radius: 4px;
  border: 1px solid #34ac2c;
  font-size: 12px;
  padding: 0px 5px;
  color: #34ac2c;
  user-select: none;
  box-sizing: border-box;
  height: 17px;
  line-height: 17px;
  display: inline-block;
  // margin-left: 15px;
  // margin-right: 10px;
}
</style>
